<app-spinner *ngIf="isLoading" placement="full-page" size="34px"></app-spinner>



<div class="chat-conversation-wrapper" *ngIf="!isLoading">

    <div class="chat-toolbar-wrapper">
        <div class="chat-info">
            <p class="party-name" *ngIf="!isLoadingUserData">{{otherUser.displayName}}</p>
            <p>-</p>
            <p class="route-name" *ngIf="!isLoadingUserData">{{friendlyRoute}}</p>
        </div>
        <div class="chat-menu-button" (click)="onToggleMenu()">
            <app-svg-loader height="20px" url="assets/svg/settings-toggle-bars.svg"></app-svg-loader>
        </div>
        <div #menu class="chat-menu" *ngIf="showMenu">
            <div class="menu-item" (click)="showDisconnect()">Disconnect</div>
            <div class="menu-item" (click)="showBlock()">Block &amp; Report</div>
        </div>
    </div>

    <div class="chat-thread-wrapper">

        <div id="ex-wrap" class="exchange-wrapper" #messagesWrapper
            [ngClass]="{'keyboard-showing': isKeyboardDoneShowing, 'high-pad': messages.length > 0}">

            <div class="system-block" *ngIf="showSystemGuide && otherUser">
                <div class="system-header">How to Coordinate</div>
                <ng-container [ngSwitch]="systemMessageCase">
                    <ng-container *ngSwitchCase="'same'">
                        <p>You are connected with {{otherUser.displayName}}. Here's the best way to handle your shared flight.
                        </p>
                        <ul>
                            <li>One person initiates the booking with NetJets, sharing co-flyer details.</li>
                            <li>NetJets verifies hour split with the second party.</li>
                            <li>Both parties are confirmed and hours are settled before you fly</li>
                        </ul>
                    </ng-container>
                    <ng-container *ngSwitchCase="'different'">
                        <p>You and {{otherUser.displayName}} belong to different providers. Coordinate directly to determine how to share this flight.</p>
                    </ng-container>
                    <ng-container *ngSwitchCase="'independent'">
                        <p>One of the parties in this connection is independent. Discuss the best way to handle booking and logistics with {{otherUser.displayName}}.</p>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <p>You are connected with {{otherUser.displayName}}. Coordinate your flight details.</p>
                    </ng-container>
                </ng-container>
            </div>

            <div class="system-block" *ngIf="!hasSharedPhone">
                <p>You can share your phone number if you'd like the other party to text you outside the system.</p>
                <a class="share-link" (click)="onShareNumberClick()">Share My Number</a>
            </div>

            <div class="system-block" *ngIf="hasSharedPhone">
                <p>{{user.displayName}} has shared their phone number ({{displayMobileNumber || user?.mobileNumber}}) and prefers to coordinate
                    via text.</p>
            </div>
            <div class="message" *ngFor="let msg of messages; let isLast = last; let i = index;">
                <div class="message-info"
                    [ngClass]="{ 'right': msg.userId === user?.id, 'left': msg.userId !== user?.id }">
                    <div class="message-avatar">
                        <ng-container *ngIf="msg.userId === user?.id">
                            <img *ngIf="optimizedProfileImgURL" [src]="optimizedProfileImgURL" alt="Profile Photo">
                            <app-svg-loader *ngIf="!optimizedProfileImgURL" height="18px"
                                url="assets/svg/user-solid.svg"></app-svg-loader>
                        </ng-container>
                        <ng-container *ngIf="msg.userId === otherUser?.id">
                            <img *ngIf="otherOptimizedProfileImgURL" [src]="otherOptimizedProfileImgURL"
                                alt="Profile Photo">
                            <app-svg-loader *ngIf="!otherOptimizedProfileImgURL" height="18px"
                                url="assets/svg/user-solid.svg"></app-svg-loader>
                        </ng-container>
                    </div>
                    <div class="message-data">
                        <app-chat-message [msg]="msg" [user]="user" [otherUser]="otherUser"
                            [justifyRight]="msg.userId === user?.id"></app-chat-message>
                    </div>
                </div>

            </div>
            <div class="message" *ngIf="isOtherUserTyping">
                <div class="message-info left">
                    <app-user-typing [imgURL]="otherOptimizedProfileImgURL"></app-user-typing>
                </div>
            </div>

            <div class="review-button" *ngIf="isFlightReadyToReview()">
                <app-primary-btn variant="review" [fluid]="true" (click)="showReview()">Add a Review</app-primary-btn>
            </div>

        </div>


    </div>
</div>

<div class="input-wrapper">
    <div class="input-container">
        <div inputWrapper class="chat-keyboard-wrapper keyboard-fixed"
            [ngClass]="{'keyboard-focused': isKeyboardFocused}">

            <div class="action-button" (click)="onSendMessage()"
                [ngClass]="{ 'active' : newMessage?.length > 1 && newMessage?.length < 2000}">
                <app-svg-loader url="assets/svg/circle-arrow-up.svg"></app-svg-loader>
            </div>

            <app-base-input id="input-el" placeholder="Message..." [(ngModel)]="newMessage" (focusEvent)="onFocus()"
                (blurEvent)="onBlur()" (onEnter)="onSendMessage()" (valueChange)="onTyping()" isFluid="true"
                hasIcon="true" autocomplete="off"></app-base-input>

            <div *ngIf="isKeyboardFocused" class="input-backdrop" (click)="onBackdropClick()"></div>
        </div>
    </div>
</div>

<app-pop-tray *ngIf="showShareTray" [header]="'Share your phone number?'"
    [description]="'This will share your number (' + (displayMobileNumber || user?.mobileNumber) + ') with your connected party.'"
    [actions]="shareActions">
</app-pop-tray>
<app-pop-tray *ngIf="showDisconnectTray" [header]="'Disconnect?'"
    [description]="'This flight connection will be removed from your account and you will no longer be able to communicate with the other party'"
    [actions]="disconnectActions"></app-pop-tray>

<app-pop-tray *ngIf="showBlockTray" [header]="'Block & Report User?'"
    [description]="'While we verify each user, we cannot vouch for them. If you are experiencing an issue with this party, please let us know and we will look into it.'"
    [actions]="blockActions">
    <app-base-text-area mb="18px" placeholder="Reason..." isFluid="true" [(ngModel)]="blockReason"></app-base-text-area>
</app-pop-tray>

<app-pop-tray *ngIf="showReviewTray" [header]="'Review User'" [description]="'How was your experience with this party?'"
    [actions]="reviewActions">
    <app-star-rating [(rating)]="reviewRating"></app-star-rating>
    <app-base-text-area mt="16px" mb="18px" placeholder="Feedback (optional)" isFluid="true"
        [(ngModel)]="reviewText"></app-base-text-area>
</app-pop-tray>